export const AGRUPADOR_PAGAMENTO_CREATE = "AGRUPADOR_PAGAMENTO_CREATE";
export const AGRUPADOR_PAGAMENTO_UPDATE = "AGRUPADOR_PAGAMENTO_UPDATE";
export const AGRUPADOR_PAGAMENTO_LOAD = "AGRUPADOR_PAGAMENTO_LOAD";
export const AGRUPADOR_PAGAMENTO_DELETE = "AGRUPADOR_PAGAMENTO_DELETE";
